import apiService from '../../apiService';

const INVOICE_URL = 'setup/invoices'
const invoiceService = {

    async createInvoice(payload) {
        try {
            const response = await apiService.post(`/${INVOICE_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllInvoice() {
        try {
            const response = await apiService.get(`/${INVOICE_URL}`,);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


    async getSingleInvoice(id) {
        try {
            const response = await apiService.get(`/${INVOICE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getFlatFeeItems(id) {
        try {
            const response = await apiService.get(`/${INVOICE_URL}/flat_fee_items_by_contact/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getExpenseCategoryItems(id) {
        try {
            const response = await apiService.get(`/${INVOICE_URL}/expense_category_by_contact/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async aprroveInvoice(id) {
        try {
            const response = await apiService.get(`/${INVOICE_URL}/approve/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateInvoice(payload, id) {
        try {
            const response = await apiService.put(`/${INVOICE_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteInvoice(id) {
        try {
            const response = await apiService.delete(`/${INVOICE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // Get Contact/Matter related data
    async getContactMatterRelatedData(relation, id) {
        try {
            const response = await apiService.get(`${INVOICE_URL}/entity_for_invoice/${relation}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async previewInvoice(id, isDownload = false) {
        try {
            const response = await apiService.get(`/${INVOICE_URL}/invoice_pdf/${id}${isDownload ? '?download' : ''}`, {
                // responseType: 'arraybuffer',
                responseType: 'blob',
                isPdf: true
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getInvoicePaymentDetails(payload = {}) {
        try {
            const response = await apiService.post(`/${INVOICE_URL}/payment_summary`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getRawDataReportInvoicePaymentSummary(formData) {
        try {
            const response = await apiService.post(`/reports/invoice_report_summary`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async sendInvoiceToContact(id) {
        try {
            const response = await apiService.get(`${INVOICE_URL}/send_invoice/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


    async verifyInvoiceToken(token) {
        try {
            const response = await apiService.get(`/get_invoice/${token}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async makeOfflineInvoicePayment(payload) {
        try {
            const response = await apiService.post(`/${INVOICE_URL}/pay_invoices`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateSettlment(id, payload) {
        try {
            const response = await apiService.put(`/${INVOICE_URL}/settlements/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async invoiceSampleFile() {
        try {
            const response = await apiService.get(`setup/download_sample_file`, {
                responseType: "blob"
            });
            return response;
        } catch (error) {
            console.log(error)
            throw error.response.data;
        }
    },
};

export default invoiceService;